import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './NewsDetails.css';
import { format, parseISO } from 'date-fns';
import renderHTML from 'react-render-html';
import { useParams } from "react-router-dom";

function NewsDetails(props) {
    const [data, setData] = useState([]);
    const [co_code, setco_code] = useState([]);
    const [filteredNewsData, setFilteredNewsData] = useState([]);
    const { fetchId } = useParams();
    const [dataGroup, setDataGroup] = useState([]);
    const [companyInfo, setCompanyInfo] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const { BaseURL } = useContext(URLstateContext);
    let getData;
    let PageSize = 8;
    let companyInformation;

    useEffect(() => {
        if (fetchId != null) {
            const getUrl = BaseURL + "News";
            fetch(`${getUrl}/-/-/${fetchId}/-`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    companyInformation = data.data;
                    // setCompanyInfo(companyInformation);
                    let filteredCompanyInformation = companyInformation.filter(oneData => { return parseInt(oneData['Sno']) === parseInt(fetchId) })
                    setFilteredNewsData(filteredCompanyInformation)
                })
                .catch((error) => {
                });
        }
    }, [fetchId]);


    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);

    return (
        <>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='snop-loser-sc'>
                            <div className='snop-header'>
                                <h2><span>News Details</span></h2>
                            </div>
                            <div className='snop-table'>
                                {filteredNewsData && filteredNewsData.map(
                                    ({ co_code, SNo, Heading, Date, Time, Arttext, Caption }) => (
                                        <>
                                            <div className="titleCompanyNews">{Heading}</div>
                                            <div className="InfoCompanyNews">{renderHTML(Arttext)}</div>
                                        </>
                                    ))}
                            </div >

                        </section>
                    </Col>
                </Row>
            </Container >

        </>
    );
}

export default NewsDetails;